import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { ListTransactionModel } from '../../models/list-transaction.model';
import { TopTransactionModel } from '../../models/top-transaction.model';
import { TransactionSummaryModel } from '../../models/transaction-summary.model';
import { TransactionModel } from '../../models/transaction.model';

@Injectable({
    providedIn: 'root'
})
export class TransactionsResource extends BaseEntityResource<TransactionModel, TransactionSummaryModel, ListTransactionModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'transactions' }));
    }

    /**
     * Returns all pending transactions.
     */
    pending(): Observable<ApiResponseModel<ListTransactionModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<ListTransactionModel[]>>(this.getUrl('pending'));
    }

    /**
     * Gets the top n transactions sorted by amount of shares.
     * @param quantity Number of top items to be returned.
     */
    top(quantity: number): Observable<ApiResponseModel<TopTransactionModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<TopTransactionModel[]>>(this.getUrl(`top/${quantity}`));
    }

    /**
     * Approves a transaction.
     * @param id ID of the transaction.
     */
    approve(id: string): Observable<ApiResponseModel<boolean>> {
        return this._requestService.makePost<ApiResponseModel<boolean>>(this.getUrl(`${id}/approve`));
    }
}
